import getApi from '../../api/apisauceConfig'
import { TranscriptionUpdateAI } from '../../model/TranscriptionAI'

export const updateTranscription = (file: Blob, uuid: string) => {
  const data = new FormData()
  data.append('file', file)

  return getApi().post<TranscriptionUpdateAI>(`/voice_ai/transcribe/${uuid}/update`, data)
}
